import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["copyValue"];

  copy (event) {
    this.copyValueTarget.value = event.currentTarget.value;
  }
}
